// extracted by mini-css-extract-plugin
module.exports = {"learn":"learn_learn__sBMCF","title":"learn_title__BRpHX","text":"learn_text__j_exh","links":"learn_links__tvyh9","link":"learn_link__IZW3r"};